@if (gated()) {
  <bit-icon
    class="tw-text-muted"
    data-testid="vault-filter-gated-collection"
    name="bwi-lock-encrypted"
    fixedWidth
    [ariaLabel]="requiresRequestLabel"
    [title]="requiresRequestLabel"
  />
}
